import React from 'react';
import {
  dispatch,
  getCatalogDownloadStatus,
  getIsSelectedAll,
  getSelectedItemIds,
  updateIsSelectedAll,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { TouchableOpacity } from '../../common';
import './field-ops-select-all-toggle.scss';
import { ReactComponent as Checkbox } from '@zonofi/svg-icons/checkbox.svg';
import { ReactComponent as Checked } from '@zonofi/svg-icons/checked.svg';

export const SelectAllToggleInHeader: React.FC<{
  handleToggleSelectAll: () => void;
  handleClearSelection?: () => void;
  showSelectAll?: boolean;
}> = ({
  handleToggleSelectAll,
  handleClearSelection = () => {},
  showSelectAll = true,
}) => {
  const isSelectedAll = useAppSelector(getIsSelectedAll);
  const selectedItemIds = useAppSelector(getSelectedItemIds);
  const catalogData = useAppSelector(getCatalogDownloadStatus);

  return (
    <div className="field-ops-select-option-container">
      {showSelectAll && (
        <TouchableOpacity
          className="field-ops-select-option-container--left"
          onPress={handleToggleSelectAll}
        >
          {isSelectedAll ? (
            <Checked color="#0067FF" width={20} height={20} />
          ) : (
            <Checkbox color="#8C8C8C" width={20} height={20} />
          )}
          <span className="field-ops-select-option-container--left-text font-semibold">
            {isSelectedAll ? 'Unselect All' : 'Select All'}
          </span>
        </TouchableOpacity>
      )}
      <div className="field-ops-select-option-container--right">
        <span
          className="field-ops-select-option-container--right-text font-semibold"
          onClick={() => {
            if (selectedItemIds?.length === 0) {
              handleClearSelection();
              dispatch(updateIsSelectedAll(false));
            }
          }}
        >
          {`${selectedItemIds?.length - (Object.entries(catalogData)?.filter(([key, val]) => val?.catalog === true && selectedItemIds?.includes(key)).length ?? 0)} Selected`}
        </span>

        {selectedItemIds?.length > 0 && (
          <div>
            <span className="field-ops-select-option-container--right-text dot-view">
              {'•'}
            </span>
            <span
              className="field-ops-select-option-container--right-text clear font-semibold"
              onClick={() => {
                handleClearSelection();
                dispatch(updateIsSelectedAll(false));
              }}
            >
              Clear
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
